import DateRangePicker from '@amzn/meridian/date-range-picker';
import moment from 'moment-timezone';
import React, { FC, useMemo } from 'react';
import { TranslationFunction } from '../../blocks';

interface CreatedDateRangeFilterProps {
    value: string[];
    onChange: (values: string[]) => void;
    t: TranslationFunction;
    timezone?: string;
}

const CreatedDateRangeFilter: FC<CreatedDateRangeFilterProps> = ({ value, onChange, t, timezone }) => {
    const tz = timezone || 'UTC';
    const today = useMemo(() => moment.tz(tz).format('YYYY-MM-DD'), [tz]);
    const sevenDaysAgo = useMemo(() => moment.tz(tz).subtract(7, 'days').format('YYYY-MM-DD'), [tz]);
    const fourteenDaysAgo = useMemo(() => moment.tz(tz).subtract(14, 'days').format('YYYY-MM-DD'), [tz]);
    const thirtyDaysAgo = useMemo(() => moment.tz(tz).subtract(30, 'days').format('YYYY-MM-DD'), [tz]);

    return (
        <DateRangePicker
            value={value}
            startId={'extraction-dateRangeStart'}
            endId={'extraction-dateRangeEnd'}
            startLabel={t('common:dateRangePicker-startPlaceholder')}
            endLabel={t('common:dateRangePicker-endPlaceholder')}
            allowSameStartAndEnd={true}
            onChange={onChange}
            monthsInView={1}
            clearButton={true}
            width={'25em'}
            presets={[
                { label: t('last7Days-preset'), value: [sevenDaysAgo, today] },
                { label: t('last14Days-preset'), value: [fourteenDaysAgo, today] },
                { label: t('last30Days-preset'), value: [thirtyDaysAgo, today] },
            ]}
        />
    );
};

export default CreatedDateRangeFilter;
